export default {
  Partnership: "price_1LITrOBNojRG2LLAQxy4WGqW",
}